import { render, staticRenderFns } from "./User.vue?vue&type=template&id=041af9b6&"
import script from "./User.vue?vue&type=script&lang=js&"
export * from "./User.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('041af9b6')) {
      api.createRecord('041af9b6', component.options)
    } else {
      api.reload('041af9b6', component.options)
    }
    module.hot.accept("./User.vue?vue&type=template&id=041af9b6&", function () {
      api.rerender('041af9b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/User.vue"
export default component.exports